<template>
  <div class="global-box registrations rectangle right">
    <div class="content-box">
      <h3>{{$t('index.registrations.title')}}</h3>
      <form class="form-global" novalidate @submit.prevent="validateData">
        <div class="global-inputs">
          <md-field class="nameUser" :class="getValidationClass('nameUser')">
            <label>{{$t('register.form.name_user')}}</label>
            <md-input v-model="formRegister.nameUser" required />
            <span class="md-error" v-if="!$v.formRegister.nameUser.required">
              {{$t('register.validate.fild_required')}}
            </span>
            <span class="md-error" v-if="!$v.formRegister.nameUser.minLength">
              {{$t('register.validate.fild_minlength')}}
            </span>
          </md-field>
          <md-field class="mailUser" :class="getValidationClass('mailUser')">
            <label>{{$t('register.form.mail_user')}}</label>
            <md-input v-model="formRegister.mailUser" required />
              <span class="md-error" v-if="!$v.formRegister.mailUser.required">
              {{$t('register.validate.fild_required')}}
            </span>
            <span class="md-error" v-if="!$v.formRegister.mailUser.email">
              {{$t('register.validate.fild_email')}}
            </span>
          </md-field>
        </div>
        <btn
          :description="$t('index.pricing.register')"
          small
          outline
          class="btn"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
  name: 'registrations',
  data() {
    return {
      formRegister: {
        nameUser: '',
        mailUser: '',
      },
    };
  },
  validations: {
    formRegister: {
      nameUser: { required, minLength: minLength(3) },
      mailUser: { required, email },
    },
  },
  methods: {
    validateData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.sendData();
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v.formRegister[fieldName];
      return (field) ? { 'md-invalid': field.$invalid && field.$dirty } : '';
    },
    sendData() {
      this.$router.push({
        name: 'registrations',
        params: {
          dataForm: {
            nameUser: this.formRegister.nameUser,
            mailUser: this.formRegister.mailUser,
          },
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .registrations
    min-height: 200px
    .content-box
      justify-content: center
    h3
      width: 100%
      text-align: center
    .form-global
      width: 70%
      display: flex
      flex-wrap: wrap
      justify-content: center
      .global-inputs
        width: 100%
        display: flex
        margin: 20px 0
        .md-field
          margin-left: 12px
          margin-right: 12px
    @media (max-width: $widthPrimarySmall)
      .content-box
        padding: 8px 52px
    @media (max-width: $widthTerciary)
      .content-box
        padding: 8px 32px
      .form-global
        .global-inputs
          flex-wrap: wrap
</style>
